import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bbca61e2"
import script from "./employeeDetails.js?vue&type=script&lang=js&external"
export * from "./employeeDetails.js?vue&type=script&lang=js&external"
import style0 from "./employeeDetails.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports